import React, { Component } from 'react';

import { Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class PracticePaymentInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticePaymentInfo = (bank, stripeAccount) => {

    const bankExists     = bank ? true : false;
    const stripe_account = stripeAccount || null;

    let outstanding_requirements = this.determineOutstandingRequirements(stripe_account);
    let edit_button_title        = bankExists ? 'Edit Bank' : 'Add Bank';
        edit_button_title        = outstanding_requirements ? 'Complete Requirements' : edit_button_title;

    let only_display_when_outstanding = this.props.displayWhenOutstanding || false;

    if (only_display_when_outstanding === true && !outstanding_requirements) {
      return null;
    }

    return <div className="standard-container">
      <Header icon='fas fa-file-invoice-dollar'
              title='Payment Information for Payouts'
              button_title={edit_button_title}
              button_action={ () => {
                this.props.practiceActions.openPracticeAddEditBank();
              }} />

      { !outstanding_requirements ? null
        : <div className='flex-container flex-container-column' style={{ marginTop: 10, padding: 15, paddingTop: 0 }}>
            <span style={{ color: 'orange', fontSize: 14 }}>Outstanding Verification Requirements</span>
            <span style={{ color: 'grey', fontSize: 14 }}>Payment verification requirements must be completed in order to process payments.</span>
          </div> }

      { !bankExists && !outstanding_requirements
        ? <div className="flex-container-row flex-center-align flex-center-justify" style={{ fontSize: 14, color: 'grey', padding: 20 }}>
            This practice has not added a bank yet
          </div>
        : null }

      { bankExists && !outstanding_requirements
        ? <div className="flex-container flex-container-row" style={{ marginTop: 5, padding: 15, paddingTop: 10, alignItems: 'center' }}>
            <span className='fas fa-money-check-alt' style={{ fontSize: 30, color: '#1dc2ff' }} />
            <div className="flex-container-column" style={{ justifyContent: 'center', marginLeft: 15 }}>
              <span style={{ fontSize: 11, color: 'grey' }}>{ bank.bank_name }</span>
              <span style={{ color: 'grey', fontSize: 13 }}>{ '********' + bank.last4 }</span>
            </div>
          </div>
        : null }

    </div>
  }

  render() {
    if (this.props.hide) {
      return null;
    }
    return this.renderPracticePaymentInfo(this.props.bank, this.props.stripeAccount);
  }

  determineOutstandingRequirements = (stripe_account) => {
    let has_outstanding = false;
    let requirements    = stripe_account && stripe_account.requirements && stripe_account.requirements.eventually_due ? stripe_account.requirements.eventually_due : [];

    has_outstanding = requirements && requirements.length && requirements.length > 0 ? true : false;

    return has_outstanding;
  }

}


export default PracticePaymentInfo
